import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import BootstrapTable from "react-bootstrap-table-next"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import { useSelector, useDispatch } from "react-redux"
import * as freelancerAction from "../../store/ZnJlZWxh/actions"
//import PropTypes from "prop-types"
import PropTypes from "prop-types"
import { get, isEmpty } from "lodash"
import { CSVExport } from "react-bootstrap-table2-toolkit"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import PhoneInput from "react-phone-number-input"
import SimpleReactValidator from "simple-react-validator"
import api from "helpers/Api"
import { ToastContainer, toast } from "react-toastify"

const ManageFreelancer = (props) => {
  const { searchBarStyle } = props
  const { SearchBar } = Search
  const dispatch = useDispatch()
  const update = useSelector((specificstate) => specificstate.freelancer)
  console.log("update is", update)

  useEffect(() => {
    dispatch(freelancerAction.loadRecordsMetaData())
    dispatch(freelancerAction.loadRecords())
    dispatch(freelancerAction.loadServiceRecords())
  }, [1])

  const { recordsMetaData = {}, records = [], service_details = [] } = update
  console.log(recordsMetaData)
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  const serviceOptions =
    !isEmpty(service_details) && service_details && service_details.length > 0
      ? service_details.map((c) =>
          Object.assign(
            {},
            { label: c.serviceName, value: c._id, servicePrice: c.amount }
          )
        )
      : []

  console.log(service_details, "service_details")
  console.log(serviceOptions, "serviceOptions")

  //modal
  const [openmodal, setOpenmodal] = useState(false)
  const [fullscreen, setFullscreen] = useState(false)
  const [editfreelancer, setEditfreelancer] = useState(false)
  const [deletemodal, setDeletemodal] = useState(false)
  // const [contractAttachment, setContractAttachment] = useState("")
  const handleModal = () => {
    setOpenmodal(false)
  }

  //freelancer state

  const [freelancerdata, setFreelancerdata] = useState({
    _id: "",
    freelancerCode: "",
    freelancerName: "",
    vendorType: "",
    equipment: "",
    phoneNumber1: "",
    phoneNumber2: "",
    whatsappNumber: "",
    emailId: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    contractAttachment: "",
    pinCode: "",
  })

  const handleChange = (e) => {
    setFreelancerdata({ ...freelancerdata, [e.target.name]: e.target.value })
  }

  const [renderPage, setRenderPage] = useState(false)
  const [bankdata, setBankdata] = useState([
    {
      bankName: "",
      bankId: "",
      accountNumber: "",
      accountName: "",
      isfcCode: "",
    },
  ])

  const addBankdetails = async () => {
    setBankdata([
      ...bankdata,
      {
        bankName: "",
        bankId: "",
        isfcCode: "",
        accountNumber: "",
        accountName: "",
      },
    ])
    setRenderPage(!renderPage)
  }

  const bankChange = (e, index, name) => {
    const bankdataList = [...bankdata]
    if (
      name === "isfcCode" ||
      name === "accountNumber" ||
      name === "accountName"
    ) {
      const value = e.target.value
      bankdataList[index][name] = value
      setBankdata(bankdataList)
    }
    if (name === "bankName") {
      const value = e.target.value
      bankdataList[index][name] = value
      setBankdata(bankdataList)
    }
    setRenderPage((prev) => !prev)
  }

  const removeBankdetails = async (toRemove) => {
    var bankdataList = bankdata
    if (toRemove != 0) {
      if (toRemove > -1) {
        bankdataList.splice(toRemove, 1)
      }
      setBankdata(bankdataList)
      setRenderPage(!renderPage)
    }
  }

  const [paymentdata, setPaymentdata] = useState({
    servicePrice: "",
    serviceId: "",
    serviceName: "",
    costPerSession: "",
    costPerDay: "",
  })
  const addPaymentdetails = () => {
    setPaymentdata([
      ...paymentdata,
      {
        servicePrice: "",
        serviceId: "",
        serviceName: "",
        costPerSession: "",
        costPerDay: "",
      },
    ])
    setRenderPage(!renderPage)
  }

  const paymentChange = (e, index, name) => {
    const paymentdataList = [...paymentdata]
    if (
      name === "servicePrice" ||
      name === "costPerSession" ||
      name === "costPerDay"
    ) {
      paymentdataList[index][name] = e.target.value
    }
    if (name === "serviceId") {
      paymentdataList[index]["serviceId"] = e.value
      paymentdataList[index]["serviceName"] = e.label
      paymentdataList[index]["servicePrice"] = e.servicePrice
    }
    setPaymentdata(paymentdataList)
    setRenderPage(!renderPage)
  }
  const removePaymentdetails = async (toRemove) => {
    var paymentList = paymentdata
    if (toRemove != 0) {
      if (toRemove > -1) {
        paymentList.splice(toRemove, 1)
      }
      setPaymentdata(paymentList)
      setRenderPage(!renderPage)
    }
  }

  //dropdown state
  const [city, setCity] = useState([])
  const [country, setCountry] = useState([])
  const [state, setState] = useState([])
  // const [equipment,setEquipment] = useState([])
  // const [vendorType,setVendorType] = useState([])

  //options
  const stateOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.stateOptions.filter(
      (state) => state.countryId === country.value
    )

  console.log(stateOptions, "statttttt")

  const cityOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.cityOptions.filter((city) => city.stateId === state.value)

  console.log(cityOptions, "kkkt")
  const [attachmentFile, setAttachmentFile] = useState([])
  const [attachment, setAttachment] = useState("")

  const attachmentChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setAttachmentFile(e.target.files)
      var file = e.target.files

      var fileArrayDetails = Array.from(file)
      var teamUploadValue = attachmentFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setAttachmentFile(teamUploadValue)
          }
        })
      }
    }
  }
  //Autofill Freelancer code
  const freeCode =
    !isEmpty(records) && records.length > 0 ? records.length + 1 : ""
  const freelancerCodeValue = "FRC" + String(freeCode).padStart(4, "0")
  console.log(freelancerCodeValue, "freeValue")

  //table data
  let slNo = 0
  const freelancerTable = records.map((free) => {
    slNo = slNo + 1
    const attachments =
      free.contractAttachment && free.contractAttachment.split(".").pop()

    var str = !isEmpty(free.contractAttachment) ? free.contractAttachment : []

    console.log(str, "string attachments")
    const fileUrl = isEmpty(str) ? "" : str.substring(str.indexOf("/"))
    console.log(fileUrl, "string attachments")
    const updateAttachments = isEmpty(fileUrl)
      ? ""
      : "https://api.alphaone.app/uploads/" + fileUrl

    const attachmentFile = !isEmpty(free.contractAttachment)
      ? free.contractAttachment
      : ""
    console.log(updateAttachments, "attachment with alpha url")

    //Multiple array's using join methods

    const account =
      !isEmpty(free.bankDetails) && free.bankDetails.length > 0
        ? free.bankDetails.map((b) => b.accountNumber)
        : ""
    const ifsc =
      !isEmpty(free.bankDetails) && free.bankDetails.length > 0
        ? free.bankDetails.map((b) => b.isfcCode)
        : ""
    const bank =
      !isEmpty(free.bankDetails) && free.bankDetails.length > 0
        ? free.bankDetails.map((b) => b.bankName)
        : ""

    const accountNumber =
      !isEmpty(account) && account && account.length > 1
        ? account.join(",")
        : account
    const ifscCode =
      !isEmpty(ifsc) && ifsc && ifsc.length > 1 ? ifsc.join(",") : ifsc
    const bankName =
      !isEmpty(bank) && bank && bank.length > 1 ? bank.join(",") : bank
    const cost =
      !isEmpty(free) &&
      free.paymentDetails.map((payment) => payment.costPerSession)

    const perSessionCost =
      !isEmpty(cost) && cost && cost.length > 0 ? cost.join(",") : cost
    const perDay =
      !isEmpty(free) && free.paymentDetails.map((payment) => payment.costPerDay)

    const perDayCost =
      !isEmpty(perDay) && perDay && perDay.length > 0
        ? perDay.join(",")
        : perDay

    return {
      _id: free._id,
      sNo: slNo,
      action: (
        <div style={{ display: "flex" }}>
          <Button
            type="submit"
            onClick={() => {
              setEditfreelancer(true)
              setOpenmodal(true)
              setFullscreen(true)
              editFreelancerDetails(free)
              setAttachment(attachmentFile)
            }}
            style={{ fontSize: "10px" }}
            className="btn btn-success buttons"
          >
            <i
              className="fas fa-pencil-alt icon-btn"
              style={{ fontSize: "13px" }}
            ></i>
          </Button>
          <Button
            type="submit"
            onClick={() => {
              editdeleteModal(free)
              setDeletemodal(true)
            }}
            style={{ fontSize: "10px", marginLeft: "20px" }}
            className="btn btn-danger buttons"
          >
            <i
              className="fas fa-trash-alt icon-btn"
              style={{ fontSize: "12px" }}
            ></i>
          </Button>
        </div>
      ),
      freelancerCode: free.freelancerCode,
      freelancerName: free.freelancerName,
      vendorType: free.vendorType,
      phoneNumber1: free.phoneNumber1,
      phoneNumber2: free.phoneNumber2,
      whatsappNumber: free.whatsappNumber,
      emailId: free.emailId,
      address1: free.address1,
      address2: free.address2,
      city: free.cityName,
      state: free.stateName,
      country: free.countryName,
      pinCode: free.pincode,
      contractAttachment:
        (free.contractAttachment && attachments === "jpeg") ||
        (free.contractAttachment && attachments === "jpg") ||
        (free.contractAttachment && attachments === "png") ? (
          <a onClick={() => window.open(free.contractAttachment, "_blank")}>
            <span
              style={{
                textDecoration: "underline",
                color: "#E40D8C",
              }}
            >
              View Attachments
            </span>
          </a>
        ) : (free.contractAttachment && attachments === "mp3") ||
          (free.contractAttachment && attachments === "m4a") ||
          (free.contractAttachment && attachments === "mp4") ? (
          <a href={free.contractAttachment}>
            <audio controls>
              <source src={free.contractAttachment} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </a>
        ) : (
          ""
        ),
      bank: bankName,
      accountNumber: accountNumber,
      ifsc: ifscCode,

      costperses: perSessionCost,
      costperday: perDayCost,
    }
  })
  //table columns

  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
      csvExport: false,
    },
    {
      dataField: "freelancerCode",
      text: "Freelancer Code",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "freelancerName",
      text: "Freelancer Name",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "vendorType",
      text: "Vendor Type",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "phoneNumber1",
      text: "Phone Number1",
      csvType: Number,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "phoneNumber2",
      text: "Phone Number2",
      csvType: Number,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "whatsappNumber",
      text: "Whatsapp Number",
      csvType: Number,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "emailId",
      text: "Email Id",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "address1",
      text: "Address 1",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "address2",
      text: "Address 2",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "country",
      text: "Country",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "state",
      text: "State",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "city",
      text: "City",
      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "pinCode",
      text: "Pincode",
      csvType: Number,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "contractAttachment",
      text: "Attachment",
      csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "bank",
      text: "Bank",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "accountNumber",
      text: "Account Number",
      csvType: Number,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "ifsc",
      text: "IFSC",
      csvType: Number,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "costperses",
      text: "Cost Per Session",
      csvType: Number,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "costperday",
      text: "Cost Per Day",
      csvType: Number,
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]
  //download feature in data table
  const { ExportCSVButton } = CSVExport
  // pagination options
  const options = {
    sizePerPage: 50,
    //totalSize: obs_list.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const editFreelancerDetails = (free) => {
    setFreelancerdata({
      ...freelancerdata,
      freelancerCode: free.freelancerCode,
      freelancerName: free.freelancerName,
      phoneNumber1: free.phoneNumber1,
      phoneNumber2: free.phoneNumber2,
      whatsappNumber: free.whatsappNumber,
      emailId: free.emailId,
      address1: free.address1,
      address2: free.address2,
      pinCode: free.pincode,
      _id: free._id,
    })
    var attachment = !isEmpty(free.contractAttachment)
      ? [free.contractAttachment]
      : []
    setAttachmentFile(attachment)
    // setContractAttachment(free.contractAttachment)
    setState({ label: free.stateName, value: free.stateId })
    setCountry({ label: free.countryName, value: free.countryId })
    setCity({ label: free.cityName, value: free.cityId })

    var bankDetailsEdit = free.bankDetails
    const bankDetailsEditUpdated = !isEmpty(bankDetailsEdit)
      ? bankDetailsEdit.map((data) => {
          return {
            // bankId: get(data, "bankId", ""),
            bankName: get(data, "bankName", ""),
            accountName: get(data, "accountName", ""),
            isfcCode: get(data, "isfcCode", ""),
            accountNumber: get(data, "accountNumber", ""),
          }
        })
      : []

    setBankdata(bankDetailsEditUpdated)

    var paymentDetailsEdit = free.paymentDetails

    const paymentDetailsEditUpdated = !isEmpty(paymentDetailsEdit)
      ? paymentDetailsEdit.map((data) => {
          return {
            servicePrice: get(data, "servicePrice", ""),
            serviceId: get(data, "serviceId", ""),
            serviceName: get(data, "serviceName", ""),
            costPerSession: get(data, "costPerSession", ""),
            costPerDay: get(data, "costPerDay", ""),
          }
        })
      : []
    setPaymentdata(paymentDetailsEditUpdated)
  }

  const bankdetailsData =
    !isEmpty(bankdata) && bankdata.length > 0
      ? bankdata.map((data) => {
          if (data) {
            return {
              // bankId: data.bankId ? data.bankId : "",
              bankName: data.bankName ? data.bankName : "",
              accountNumber: data.accountNumber,
              accountName: data.accountName,
              isfcCode: data.isfcCode,
            }
          }
        })
      : []
  console.log(bankdetailsData, "bankdetailsdata")
  const paymentdetailsData =
    !isEmpty(paymentdata) && paymentdata.length > 0
      ? paymentdata.map((data) => {
          if (data) {
            return {
              servicePrice: data.servicePrice,
              serviceId: data.serviceId,
              serviceName: data.serviceName,
              costPerSession: data.costPerSession,
              costPerDay: data.costPerDay,
            }
          }
        })
      : []

  const addFreelancer = (e) => {
    e.preventDefault()
    // const formValid =
    if (simpleValidator.current.allValid()) {
      const record = {
        freelancerCode: freelancerdata.freelancerCode,
        freelancerName: freelancerdata.freelancerName,
        vendorType: "single",
        // "equipmentId": "",
        // "equipmentName":"",
        phoneNumber1: freelancerdata.phoneNumber1,
        phoneNumber2: freelancerdata.phoneNumber2,
        whatsappNumber: freelancerdata.whatsappNumber,
        emailId: freelancerdata.emailId,
        address1: freelancerdata.address1,
        address2: freelancerdata.address2,
        pincode: freelancerdata.pinCode,
        cityId: city.value,
        stateId: state.value,
        countryId: country.value,
        cityName: city.label,
        countryName: country.label,
        stateName: state.label,
        contractAttachment: attachmentFile[0],
        bankDetails: bankdetailsData,
        paymentDetails: paymentdetailsData,
        // vendorMembers:addVendorMembers
      }
      console.log(record, "add data")
      dispatch(freelancerAction.createRecord(record))

      setTimeout(() => {
        toast.success("Freelancer Added successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        dispatch(freelancerAction.loadRecords())
      }, 1000)
      setOpenmodal(false)
    } else {
      simpleValidator.current.showMessages()
      setOpenmodal(true)
      forceUpdate(1)
    }
  }

  // Update Freelancer //
  const updateFreelancerbyId = () => {
    // const formValid2 = simpleValidator.current.allValid()
    // if (!formValid2) {
    //   simpleValidator.current.showMessages()
    //   forceUpdate(1)
    // } else {
    const record = {
      _id: freelancerdata._id,
      freelancerCode: freelancerdata.freelancerCode,
      freelancerName: freelancerdata.freelancerName,
      vendorType: "single",
      //   "equipmentId": "",
      //  "equipmentName":"",
      phoneNumber1: freelancerdata.phoneNumber1,
      phoneNumber2: freelancerdata.phoneNumber2,
      whatsappNumber: freelancerdata.whatsappNumber,
      emailId: freelancerdata.emailId,
      address1: freelancerdata.address1,
      address2: freelancerdata.address2,
      pincode: freelancerdata.pinCode,
      cityId: city.value,
      stateId: state.value,
      countryId: country.value,
      cityName: city.label,
      countryName: country.label,
      stateName: state.label,
      contractAttachment: attachmentFile[0],
      bankDetails: bankdetailsData,
      paymentDetails: paymentdetailsData,
      // vendorMembers:addVendorMembers
    }
    console.log(record, "update data")
    dispatch(freelancerAction.updateRecord(record))
    setTimeout(() => {
      dispatch(freelancerAction.loadRecords())
      toast.success("Freelancer Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setOpenmodal(false)
    }, 1000)
    clearData()
    // }
  }
  console.log(freelancerdata.phoneNumber1, "freelancerdata")
  console.log(freelancerdata.phoneNumber2, "freelancerdata2")
  const clearData = () => {
    setFreelancerdata({
      ...freelancerdata,
      freelancerCode: freelancerCodeValue,
      freelancerName: "",
      vendorType: "",
      equipment: "",
      phoneNumber1: "",
      phoneNumber2: "",
      whatsappNumber: "",
      emailId: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      pinCode: "",
    })
    setState([])
    setCountry([])
    setCity([])
    setAttachmentFile([]),
      setPaymentdata([
        {
          ...paymentdata,
          servicePrice: "",
          service: "",
          costPerSession: "",
          costPerDay: "",
        },
      ])
    setBankdata([
      {
        ...bankdata,
        // bankId: "",
        bankName: "",
        accountNumber: "",
        isfcCode: "",
      },
    ])
  }

  //delete freelancer
  const editdeleteModal = (free) => {
    setFreelancerdata({ ...freelancerdata, _id: free._id })
  }

  const deleteFreelancer = () => {
    const deleteData = {
      freelancerId: [freelancerdata._id],
      status: 3,
    }
    console.log(deleteData, "delete id")
    dispatch(freelancerAction.deleteRecord(deleteData))
    setTimeout(() => {
      dispatch(freelancerAction.loadRecords())
      toast.success("Freelancer Deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  const title = "Freelancer"
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid></Container>
      <Breadcrumbs title={"Master"} breadcrumbItem={title} />
      <Row>
        <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
          <div className="filter-buttons" style={{ float: "right" }}>
            <Button
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                border: "none",
                marginTop: "-35px",
              }}
              onClick={() => {
                setOpenmodal(true)
                setFullscreen(true)
                clearData()
                setEditfreelancer(false)
              }}
            >
              Add Freelancer
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(options)}
                keyField="_id"
                columns={columns}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <ToolkitProvider
                    keyField="_id"
                    data={freelancerTable}
                    columns={columns}
                    search
                    exportCSV
                  >
                    {(props) => (
                      <div>
                        <Col md="12" xl="12" lg="12" sm="12" xs="12">
                          <Row className="d-flex flex-row  ">
                            <Col className="mb-3" md="4">
                              <div className="d-flex flex-row ">
                                <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                  <div
                                    className="position-relative mt-7"
                                    style={searchBarStyle || null}
                                  >
                                    <SearchBar {...props.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </div>{" "}
                            </Col>

                            <Col>
                              <ExportCSVButton
                                className="border float-right mx-10"
                                style={{
                                  float: "right",
                                  backgroundColor: "#e40d8c",
                                  color: "#ffffff",
                                }}
                                {...props.csvProps}
                              >
                                Download{" "}
                              </ExportCSVButton>{" "}
                            </Col>
                            <Col>
                              <BootstrapTable
                                {...props.baseProps}
                                responsive
                                striped={true}
                                bordered={true}
                                keyField="_id"
                                columns={columns}
                                {...paginationTableProps}
                              />
                            </Col>
                          </Row>
                          <Row
                            style={{ marginTop: "5px" }}
                            className="align-items-md-center mt-30"
                          >
                            <Col className="inner-custom-pagination d-flex">
                              <div className="d-inline d-flex flex-row">
                                <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginTop: "8px",
                                    marginLeft: "4px",
                                  }}
                                >
                                  <PaginationTotalStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </div>
                              <div
                                className="text-md-right ms-auto"
                                style={{ zIndex: 0 }}
                              >
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {openmodal && (
        <Modal show={openmodal} onHide={handleModal} fullscreen={fullscreen}>
          <Modal.Header
            style={{
              backgroundColor: "white",
              color: "black",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <Col xl="12" md="12" lg="12" sm="12" xs="12">
              <div className="sales-modal-header">
                <h4
                  className="modal-title mt-0 sales-modal-title"
                  id="myModalLabel"
                >
                  {editfreelancer ? "EDIT FREELANCER" : "ADD FREELANCER"}
                </h4>
                <span>
                  <i
                    className="fa fa-times quote-close"
                    aria-hidden="true"
                    onClick={() => setOpenmodal(false)}
                  ></i>
                </span>
              </div>
            </Col>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Card
                style={{
                  backgroundColor: "rgba(211,211,211,0.13)",
                  padding: "15px,15px,0px",
                  border: "2px solid rgb(239, 242, 247)",
                  boxShadow: "none",
                }}
              >
                <CardBody>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Freelancer Code"}
                        >
                          {"Freelancer Code"}
                          <span className="required">*</span>
                        </Label>
                      </div>

                      <Input
                        type="text"
                        name="freelancerCode"
                        value={freelancerdata.freelancerCode}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Freelancer Code"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "freelancerCode",
                          freelancerdata.freelancerCode,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Freelancer Name"}
                        >
                          {"Freelancer Name"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        name="freelancerName"
                        value={freelancerdata.freelancerName}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Freelancer Name"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "freelancerName",
                          freelancerdata.freelancerName,
                          "required"
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Vendor Name"}>
                          {"Phone Number 1"}
                          <span className="required">*</span>
                        </Label>
                      </div>

                      <PhoneInput
                        maxlength={15}
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry={"IN"}
                        name="phoneNumber1"
                        style={{ flex: "2" }}
                        value={freelancerdata.phoneNumber1}
                        onChange={(e) => {
                          console.log("-------", e)
                          const re = /^[0-9\b/+]+$/
                          if (e === "" || re.test(e)) {
                            handleChange({
                              target: {
                                name: "phoneNumber1",
                                value: e,
                              },
                            })
                          } else {
                            handleChange({
                              target: {
                                name: "phoneNumber1",
                                value: "",
                              },
                            })
                          }
                        }}
                        placeholder="+91"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "phoneNumber1",
                          freelancerdata.phoneNumber1,
                          "required"
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Phone Number"}
                        >
                          {"Phone Number 2"}
                        </Label>
                      </div>
                      <PhoneInput
                        maxlength={15}
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry={"IN"}
                        name="phoneNumber2"
                        style={{ flex: "2" }}
                        value={freelancerdata.phoneNumber2}
                        onChange={(e) => {
                          console.log("-------", e)
                          const re = /^[0-9\b/+]+$/
                          if (e === "" || re.test(e)) {
                            handleChange({
                              target: {
                                name: "phoneNumber2",
                                value: e,
                              },
                            })
                          } else {
                            handleChange({
                              target: {
                                name: "phoneNumber2",
                                value: "",
                              },
                            })
                          }
                        }}
                        placeholder="+91"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Whatsapp Number"}
                        >
                          {"Whatsapp Number"}
                          <span className="required">*</span>
                        </Label>
                      </div>

                      <PhoneInput
                        maxlength={15}
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry={"IN"}
                        name="whatsappNumber"
                        style={{ flex: "2" }}
                        value={freelancerdata.whatsappNumber}
                        onChange={(e) => {
                          console.log("-------", e)
                          const re = /^[0-9\b/+]+$/
                          if (e === "" || re.test(e)) {
                            handleChange({
                              target: {
                                name: "whatsappNumber",
                                value: e,
                              },
                            })
                          } else {
                            handleChange({
                              target: {
                                name: "whatsappNumber",
                                value: "",
                              },
                            })
                          }
                        }}
                        placeholder="+91"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "phoneNumber1",
                          freelancerdata.whatsappNumber,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Emailid"}>
                          {"Email"}
                          <span className="required">*</span>
                        </Label>
                      </div>

                      <Input
                        type="email"
                        name="emailId"
                        value={freelancerdata.emailId}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter EmailId"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "emailId",
                          freelancerdata.emailId,
                          "required|email"
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Address"}>
                          {"Address 1"}
                          <span className="required">*</span>
                        </Label>
                      </div>

                      <Input
                        type="text"
                        name="address1"
                        value={freelancerdata.address1}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Address 1"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "address1",
                          freelancerdata.address1,
                          "required"
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Address"}>
                          {"Address 2"}
                        </Label>
                      </div>

                      <Input
                        type="text"
                        name="address2"
                        value={freelancerdata.address2}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Address 2"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Contry"}>
                          {"Country"}
                        </Label>
                      </div>

                      <Select
                        type="text"
                        name="country"
                        value={country}
                        onChange={(e) => setCountry(e)}
                        placeholder="Select"
                        classNamePrefix="select2-selection"
                        options={recordsMetaData.countryOptions}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Contry"}>
                          {"State"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="state"
                        value={state}
                        onChange={(e) => setState(e)}
                        placeholder="Select"
                        classNamePrefix="select2-selection"
                        options={stateOptions}
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Contry"}>
                          {"City"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="city"
                        value={city}
                        onChange={(e) => setCity(e)}
                        placeholder="Select"
                        classNamePrefix="select2-selection"
                        options={cityOptions}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Pin Code"}>
                          {"Pincode"}
                        </Label>
                      </div>
                      <Input
                        type="text"
                        name="pinCode"
                        value={freelancerdata.pinCode}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Pincode"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"attachment"}>
                          {"Contract Attachment"}
                        </Label>
                      </div>
                      <Input
                        type="file"
                        name="attachmentFile"
                        accept="application/pdf, audio/mp3 , image/jpeg"
                        // id="upload-btn"
                        multiple
                        onChange={(e) => attachmentChange(e)}
                        placeholder="Select"
                      />
                      {editfreelancer && !isEmpty(attachment) ? (
                        <div className="mt-2">
                          <a onClick={() => window.open(attachment, "_blank")}>
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#E40D8C",
                              }}
                            >
                              View Attachments
                            </span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Row>
            <Row>
              <Card
                style={{
                  backgroundColor: "rgba(211,211,211,0.13)",
                  padding: "15px,15px,0px",
                  border: "2px solid rgb(239, 242, 247)",
                  boxShadow: "none",
                }}
              >
                <CardBody>
                  <Row className="mt-3">
                    <Col lg="9" md="9" sm="12">
                      <p
                        style={{
                          //color: "#4486eb",
                          margin: "0px",
                          marginRight: "15px",
                          marginTop: "15px",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        Bank Details
                      </p>
                    </Col>
                    <Col lg="3" md="3" sm="12">
                      <Button
                        style={{
                          backgroundColor: "#4486eb",
                          border: "none",
                          marginTop: "20px",
                          float: "right",
                        }}
                        onClick={() => {
                          addBankdetails()
                        }}
                      >
                        Add More
                      </Button>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="12" md="12" sm="12" className="mt-3">
                      <Table bordered>
                        <thead>
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Bank
                            </th>
                            <th
                              style={{
                                width: "20%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              IFSC{" "}
                            </th>
                            <th
                              style={{
                                width: "20%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Account Name{" "}
                            </th>
                            <th
                              style={{
                                width: "20%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Account Number
                            </th>
                            <th
                              style={{
                                width: "20%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              #
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {bankdata &&
                            bankdata.length > 0 &&
                            bankdata.map((item, index) => {
                              return (
                                <>
                                  <tr className="bg-white" key={index}>
                                    <td style={{ width: "20%" }}>
                                      {" "}
                                      <Input
                                        type="text"
                                        name="bankName"
                                        value={item.bankName}
                                        onChange={(e) =>
                                          bankChange(e, index, "bankName")
                                        }
                                        placeholder="Enter Bank Name"
                                      />
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      <Input
                                        type="text"
                                        name="isfcCode"
                                        value={item.isfcCode}
                                        onChange={(e) =>
                                          bankChange(e, index, "isfcCode")
                                        }
                                        placeholder="Enter IFSC"
                                      />
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      <Input
                                        type="text"
                                        name="accountName"
                                        value={item.accountName}
                                        onChange={(e) =>
                                          bankChange(e, index, "accountName")
                                        }
                                        placeholder="Enter Account Name"
                                      />
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      <Input
                                        type="text"
                                        name="accountNumber"
                                        value={item.accountNumber}
                                        onChange={(e) =>
                                          bankChange(e, index, "accountNumber")
                                        }
                                        placeholder="Enter Account Number"
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <i
                                        className="fa fa-times remove-icon"
                                        onClick={() => removeBankdetails(index)}
                                      ></i>
                                    </td>
                                  </tr>
                                </>
                              )
                            })}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Row>

            <Row>
              <Card
                style={{
                  backgroundColor: "rgba(211,211,211,0.13)",
                  padding: "15px,15px,0px",
                  border: "2px solid rgb(239, 242, 247)",
                  boxShadow: "none",
                }}
              >
                <CardBody>
                  <Row className="mt-3">
                    <Col lg="9" md="9" sm="12">
                      <p
                        style={{
                          margin: "0px",
                          marginRight: "15px",
                          marginTop: "15px",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        Service Details
                      </p>
                    </Col>
                    <Col lg="3" md="3" sm="12">
                      <Button
                        style={{
                          backgroundColor: "#4486eb",
                          border: "none",
                          marginTop: "20px",
                          float: "right",
                        }}
                        onClick={() => {
                          addPaymentdetails()
                        }}
                      >
                        Add More
                      </Button>
                    </Col>
                  </Row>

                  <Row style={{ marginBottom: "2%" }}>
                    <Col lg="12" md="12" sm="12" className="mt-3">
                      <Table>
                        <thead>
                          <tr>
                            <th
                              style={{
                                width: "25%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Service
                            </th>
                            <th
                              style={{
                                width: "25%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Service Price
                            </th>
                            <th
                              style={{
                                width: "25%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Cost Per Session{" "}
                            </th>
                            <th
                              style={{
                                width: "25%",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Cost Per Day
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              #
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {paymentdata &&
                            paymentdata.length > 0 &&
                            paymentdata.map((data, index) => {
                              return (
                                <>
                                  <tr className="bg-white" key={index}>
                                    <td>
                                      <Select
                                        type="text"
                                        name="serviceId"
                                        value={
                                          data.serviceId
                                            ? {
                                                value: data.serviceId,
                                                label: data.serviceName,
                                              }
                                            : { value: "", label: "Select" }
                                        }
                                        onChange={(e) =>
                                          paymentChange(e, index, "serviceId")
                                        }
                                        placeholder="Enter"
                                        classNamePrefix="select2-selection"
                                        options={serviceOptions}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {data.serviceId &&
                                      !isEmpty(serviceOptions)
                                        ? serviceOptions.find(
                                            (_) => data.serviceId === _.value
                                          )?.servicePrice ?? ""
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      <Input
                                        type="text"
                                        name="costPerSession"
                                        value={data.costPerSession}
                                        onChange={(e) =>
                                          paymentChange(
                                            e,
                                            index,
                                            "costPerSession"
                                          )
                                        }
                                        placeholder="Cost Per Session"
                                      />
                                    </td>
                                    <td style={{ width: "25%" }}>
                                      {" "}
                                      <Input
                                        type="text"
                                        name="costPerDay"
                                        value={data.costPerDay}
                                        onChange={(e) =>
                                          paymentChange(e, index, "costPerDay")
                                        }
                                        placeholder="Cost Per Day"
                                      />
                                    </td>
                                    <td>
                                      {" "}
                                      <i
                                        className="fa fa-times remove-icon"
                                        onClick={() =>
                                          removePaymentdetails(index)
                                        }
                                      ></i>{" "}
                                    </td>
                                  </tr>
                                </>
                              )
                            })}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Col>
              <div style={{ float: "right" }}>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => setOpenmodal(false)}
                >
                  Cancel
                </Button>
                {editfreelancer ? (
                  <Button
                    style={{ marginLeft: "20px" }}
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      updateFreelancerbyId()
                    }}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    style={{ marginLeft: "20px" }}
                    variant="primary"
                    className="btn btn-success"
                    onClick={(e) => {
                      addFreelancer(e)
                    }}
                  >
                    Submit
                  </Button>
                )}
                {/* <Button
                  style={{ marginLeft: "20px" }}
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => {
                    editfreelancer && editfreelancer
                      ? updateFreelancerbyId()
                      : addFreelancer()
                  }}
                >
                  {editfreelancer && editfreelancer ? "Update" : "Submit"}
                </Button> */}
              </div>
            </Col>
          </Modal.Footer>
        </Modal>
      )}
      {deletemodal && (
        <Modal show={deletemodal} size="md">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              minHeight: "65px",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            {"Delete Freelancer"}
          </Modal.Header>
          <Modal.Body>Do you want To Delete the Freelancer?</Modal.Body>
          <Modal.Footer>
            <div>
              <Button
                type="submit"
                onClick={() => {
                  deleteFreelancer()
                  setTimeout(() => {
                    setDeletemodal(false)
                  }, 500)
                }}
                style={{ fontSize: "10px", marginLeft: "20px" }}
                className="btn btn-success buttons"
              >
                {" "}
                Yes
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  setDeletemodal(false)
                }}
                style={{ fontSize: "10px", marginLeft: "20px" }}
                className="btn btn-danger buttons"
              >
                {" "}
                No
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

ManageFreelancer.propTypes = {
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageFreelancer)
)
